import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalRoutingModule } from './portal-routing.module';
import { SharedModule } from '../shared/shared.module';
import { SubscriptionAccountComponent } from './account-console-test/subscription-account/subscription-account.component';
import { AccountCreateAccountComponent } from './account-console-test/account-create-account/account-create-account.component';
import { EditAccountComponent } from './account-console-test/edit-account/edit-account.component';
import { SubscriptionManagementComponent } from './account-console-test/subscription-management/subscription-management.component';
import { SubscriptionInformationComponent } from './account-console-test/subscription-information/subscription-information.component';
import { SubscriptionListComponent } from './account-console-test/subscription-list/subscription-list.component';
import { ListUsersAssociatedComponent } from './account-console-test/list-users-associated/list-users-associated.component';
import { AccountManagementComponent } from './account-console-test/account-management/account-management.component';
import { MulticompanyComponent } from './account-console-test/multicompany/multicompany.component';
import { ImportExportHomeComponent } from './account-console-test/import-export-management/import-export-home.component';
import { ImportManagementComponent } from './account-console-test/import-export-management/import-management/import-management.component';
import { ExportManagementComponent } from './account-console-test/import-export-management/export-management/export-management.component';
import { HistoryImpExpComponent } from './account-console-test/import-export-management/history-imp-exp/history-imp-exp.component';
import { AccountTableComponent } from './account-console-test/tables/account-table/account-table.component';
import { SubscriptionTableComponent } from './account-console-test/tables/subscription-table/subscription-table.component';
import { AccountListTableComponent } from './account-console-test/tables/table/account-list-table.component';
import { MagoWebManagementComponent } from './magoweb-management/magoweb-management.component';
import { MagoWebStepperComponent } from './magoweb-management/magoweb-stepper/magoweb-stepper.component';
import { MagowebDashboardComponent } from './magoweb-management/magoweb-dashboard/magoweb-dashboard.component';
import { AdvancedSettingsComponent } from './account-console-test/advanced-settings/advanced-settings.component';
import { MagoWebNfsComponent } from './magoweb-management/magoweb-nfs/magoweb-nfs.component';
import { MagowebNfsStepperComponent } from './magoweb-management/magoweb-nfs/magoweb-nfs-stepper/magoweb-nfs-stepper.component';
import { MyUsersComponent } from './my-users/my-users.component';
import { UsersListComponent } from './my-users/users-list/users-list.component';
import { RankingManagementComponent } from './ranking-management/ranking-management.component';
import { ProductsDownloadComponent } from './products-download/products-download.component';
import { ProductCardComponent } from './products-download/product-card/product-card.component';
import { ProductVersionCardComponent } from './products-download/product-version-card/product-version-card.component';
import { FamilyProductsComponent } from './products-download/family-products/family-products.component';
import { ProductViewerComponent } from './products-download/product-viewer/product-viewer.component';
import { ProductReleasesTable } from './products-download/product-releases-table/product-releases-table.component';
import { MagoCoursesComponent } from './mago-university/mago-courses/mago-courses.component';
import { CoursesViewerComponent } from './mago-university/courses-viewer/courses-viewer.component';
import { CoursesPlanListComponent } from './mago-university/courses-plan-list/courses-plan-list.component';
import { MagoUniversityComponent } from './mago-university/mago-university.component';
import { TrainingRequestComponent } from './mago-university/training-request/training-request.component';
import { ContactsInfoComponent } from './contacts-info/contacts-info.component';
import { TechnicalSupportComponent } from './technical-support/technical-support.component';
import { MulticompanySectionComponent } from './my-users/users-list/multicompany-section/multicompany-section.component';
import { BugsReportComponent } from './technical-support/bugs-report/bugs-report.component';
import { ReleaseNotesComponent } from './technical-support/release-notes/release-notes.component';
import { CourseDetailComponent } from '../portal/mago-university/course-detail/course-detail.component';
import { ProductImprovementsComponent } from '../portal/products-download/product-improvements/product-improvements.component';
import { ProductImprovementDetailsComponent } from './technical-support/product-improvement-details/product-improvement-details.component';
import { ProductBugsComponent } from '../portal/products-download/product-bugs/product-bugs.component';
import { ProductBugDetailsComponent } from './technical-support/product-bug-details/product-bug-details.component';
import { ProductBugsReleasesFounderComponent } from '../portal/products-download/product-bugs-releases-founder/product-bugs-releases-founder.component';
import { ImprovementRequestsComponent } from '../portal/improvement-requests/improvement-requests.component';
import { BugsImprovementFinderComponent } from '../portal/technical-support/bugs-improvement-finder/bugs-improvement-finder.component';
import { IncidentsFinder } from './technical-support/incidents-finder/incidents-finder.component';
import { M4passkeyGeneratorComponent } from './technical-support/m4passkey-generator/m4passkey-generator.component';
import { BugsReportIntroComponent } from './technical-support/bugs-report-intro/bugs-report-intro.component';
import { FavouritesCoursesListComponent } from './mago-university/favourites-courses-list/favourites-courses-list.component';
import { IncidentsComponent } from './technical-support/incidents/incidents.component';
import { IncidentDetailsComponent } from './technical-support/incident-details/incident-details.component';
import { MagocloudDashboardComponent } from './magocloud-management/magocloud-dashboard/magocloud-dashboard.component';
import { MagocloudStepperComponent } from './magocloud-management/magocloud-stepper/magocloud-stepper.component';
import { MagocloudManagementComponent } from './magocloud-management/magocloud-management.component';
import { VerticalSolutionsComponent } from './vertical-solutions/vertical-solutions.component';
import { VerticalSolutionsManagementComponent } from './vertical-solutions/vertical-solutions-management/vertical-solutions-management.component';
import { CryptSalesModulesComponent } from './vertical-solutions/crypt-sales-modules/crypt-sales-modules.component';
import { GenerateSerialNumbersComponent } from './vertical-solutions/generate-serial-numbers/generate-serial-numbers.component';
import { KeyGenerationComponent } from './vertical-solutions/key-generation/key-generation.component';
import { InsertNewSolutionComponent } from './vertical-solutions/insert-new-solution/insert-new-solution.component';
import { VerticalSolutionsListComponent } from './vertical-solutions/vertical-solutions-list/vertical-solutions-list.component';
import { ReportsComponent } from './technical-support/reports/reports.component';

const COMPONENTS = [
    SubscriptionAccountComponent,
    AccountCreateAccountComponent,
    EditAccountComponent,
    SubscriptionManagementComponent,
    SubscriptionInformationComponent,
    SubscriptionListComponent,
    ListUsersAssociatedComponent,
    AccountManagementComponent,
    ImportExportHomeComponent,
    ImportManagementComponent,
    ExportManagementComponent,
    HistoryImpExpComponent,
    MulticompanyComponent,
    AccountListTableComponent,
    AccountTableComponent,
    SubscriptionTableComponent,
    MagoWebManagementComponent,
    MagoWebStepperComponent,
    MagowebDashboardComponent,
    AdvancedSettingsComponent,
    MagoWebNfsComponent,
    MyUsersComponent,
    UsersListComponent,
    RankingManagementComponent,
    ProductsDownloadComponent,
    ProductCardComponent,
    ProductVersionCardComponent,
    FamilyProductsComponent,
    ProductViewerComponent,
    ProductReleasesTable,
    MagoCoursesComponent,
    MagoUniversityComponent,
    CoursesViewerComponent,
    TrainingRequestComponent,
    ContactsInfoComponent,
    CoursesPlanListComponent,
    TechnicalSupportComponent,
    MulticompanySectionComponent,
    BugsReportComponent,
    CourseDetailComponent,
    ReleaseNotesComponent,
    ProductImprovementsComponent,
    ProductImprovementDetailsComponent,
    ProductBugsComponent,
    ProductBugDetailsComponent,
    ProductBugsReleasesFounderComponent,
    ImprovementRequestsComponent,
    BugsImprovementFinderComponent,
    M4passkeyGeneratorComponent,
    FavouritesCoursesListComponent,
    BugsReportIntroComponent,
    IncidentsFinder,
    IncidentsComponent,
    IncidentDetailsComponent,
    BugsReportIntroComponent,
    MagowebNfsStepperComponent,
    MagocloudManagementComponent,
    MagocloudDashboardComponent,
    MagocloudStepperComponent,
    VerticalSolutionsComponent,
    VerticalSolutionsManagementComponent,
    CryptSalesModulesComponent,
    GenerateSerialNumbersComponent,
    KeyGenerationComponent,
    InsertNewSolutionComponent,
    VerticalSolutionsListComponent,
    ReportsComponent
];

@NgModule({
    declarations: [COMPONENTS],
    exports: [COMPONENTS],
    imports: [CommonModule, SharedModule, PortalRoutingModule],
})
export class PortalModule {}
